<template>
  <div id="admin-account-list" class="h-full">
    <!-- 右上アクションボタン領域 -->
    <div class="flex flex-wrap justify-between items-center">
      <div class="flex w-1/3 justify-start pl-2">
        <div class="aisea-text-18-600-dark-gray">陸上従業員一覧</div>
      </div>
      <div class="flex w-1/3 justify-center items-center">
        <div
          class="list-type-button mr-2"
          :class="[
            listType !== 'inviting'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer;"
          @click="listType = 'default'"
        >
          アカウント発行済
        </div>
        <div
          class="list-type-button ml-2"
          :class="[
            listType === 'inviting'
              ? 'list-type-button--selected'
              : 'list-type-button--default',
          ]"
          style="cursor: pointer;"
          @click="listType = 'inviting'"
        >
          アカウント招待中
        </div>
      </div>
      <div class="flex w-1/3 justify-end items-center">
        <div
          ref="searchQueryBox"
          class="flex justify-end items-center mr-2"
          style="height: 3.2rem;"
        >
          <vs-tooltip text="検索" position="bottom">
            <div v-show="listType !== 'inviting'">
              <div
                class="flex w-full justify-end items-center"
                style="position: relative;"
                @click="changeSearchQueryBoxWidth()"
              >
                <vs-input
                  ref="incrementalSearch"
                  icon="search"
                  :placeholder="incrementalSearchPlaceholder"
                  v-model="searchQueryString"
                  class="crew-incremental-search"
                  :color="AISEA_COLOR.GRAY"
                />
                <vs-icon
                  v-show="searchQueryString != ''"
                  icon="clear"
                  :color="AISEA_COLOR.GRAY"
                  size="20px"
                  style="position: absolute; right: 0.4rem;"
                  ref="incrementalSearchClear"
                  @click="clearSearchQueryString"
                />
              </div>
            </div>
          </vs-tooltip>
        </div>

        <vs-tooltip text="招待" position="bottom">
          <vs-button
            icon="mail_outline"
            :color="AISEA_COLOR.BLUE"
            type="border"
            style="margin: 0 0.6rem; height: 2.7rem;"
            @click="showInvitePrompt = true"
            ><span class="aisea-text-14-400-blue">招待</span></vs-button
          >
        </vs-tooltip>
      </div>
    </div>
    <vs-divider :color="AISEA_COLOR.LIGHT_GRAY" class="mt-2 mb-0" />

    <template v-if="listType == 'default'">
      <!-- AgGrid Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        @sortChanged="onSort"
        class="ag-theme-material w-full ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="tableData"
        domLayout="autoHeight"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :suppressMovableColumns="true"
        :suppressPaginationPanel="true"
        :suppressDragLeaveHidesColumns="true"
        :suppressCellFocus="true"
        :suppressRowClickSelection="true"
        :suppressNoRowsOverlay="false"
      />

      <!-- ページネーション領域 -->
      <crew-pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :totalElement="totalElement"
        @onChangePageSize="onChangePageSize"
        @onChangePage="onChangePage"
      ></crew-pagination>
    </template>
    <template v-else>
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full ag-grid-table"
        :columnDefs="invitationColumnDefs"
        :defaultColDef="defaultInviteColDef"
        :rowData="tableData"
        domLayout="autoHeight"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :suppressMovableColumns="true"
        :suppressPaginationPanel="true"
        :suppressDragLeaveHidesColumns="true"
        :suppressCellFocus="true"
        :suppressRowClickSelection="true"
        :suppressNoRowsOverlay="false"
      />
    </template>

    <!-- 新規ボタン領域 -->
    <div
      id="admin-account-list-add-button"
      style="display: none; position: absolute;"
    >
      <div class="flex w-full justify-center" style="flex-direction: column;">
        <div
          id="admin-account-list-add-button-msg"
          class="aisea-text-16-400-black mb-4"
        ></div>
        <div class="flex w-full justify-center">
          <vs-button
            icon="add"
            :color="AISEA_COLOR.BLUE"
            type="border"
            style="margin: 0 0.6rem; height: 2.7rem;"
            @click="showCrewSidebarForCreate(false)"
            ><span class="aisea-text-14-400-blue">招待</span></vs-button
          >
        </div>
      </div>
    </div>

    <vs-prompt
      title="陸上従業員情報編集"
      :color="AISEA_COLOR.BLUE"
      :active.sync="showEditPrompt"
      buttons-hidden
      class="manning-vessel-list-edit-confirm"
    >
      <admin-account-basic-info-edit
        :inputParam="{
          enterprise_account_id: targetRowData
            ? targetRowData.enterprise_account_id
            : null,
          profile: targetRowData,
          picture: null,
        }"
        @close="showEditPrompt = false"
        @reloadList="fetchTableData(listType)"
        @updatedId="
          id => {
            pushUpdatedId(id);
          }
        "
      />
    </vs-prompt>

    <vs-prompt
      title="陸上従業員招待"
      :color="AISEA_COLOR.BLUE"
      :active.sync="showInvitePrompt"
      buttons-hidden
      class="manning-vessel-list-edit-confirm"
    >
      <admin-account-invite
        :inputParam="{}"
        @close="showInvitePrompt = false"
        @reloadList="fetchTableData(listType)"
      />
    </vs-prompt>

    <vs-prompt
      title="陸上従業員アカウント削除"
      type="alert"
      :color="AISEA_COLOR.BLUE"
      accept-text="実行"
      cancel-text="キャンセル"
      :active.sync="showDeletePrompt"
      @accept="onDelete"
      @cancel="onDeleteCancel"
      class="admin-account-list-delete-confirm"
    >
      <div class="admin-account-list-delete-confirm-body">
        {{
          targetRowData ? targetRowData.name : ""
        }}の登録情報を削除しますか？<br />
        削除したデータは戻せません。
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import Vue from "vue";
import moment from "moment-timezone";
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererPassword from "./cell-renderer/CellRendererPassword.vue";
import CellRendererRowActionButtons from "./cell-renderer/CellRendererRowActionButtons.vue";
import CrewPagination from "../components/CrewPagination.vue";
import AdminAccountBasicInfoEdit from "../admin-account-list/components/AdminAccountBasicInfoEdit.vue";
import AdminAccountInvite from "../admin-account-list/components/AdminAccountInvite.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseAdminAccountApi = AiseaApiFactory.get("enterpriseAdminAccount");
const enterpriseAdminAccountInviteApi = AiseaApiFactory.get(
  "enterpriseAdminAccountInvite"
);

import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererLink,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererPassword,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRowActionButtons,
    CrewPagination,
    AdminAccountBasicInfoEdit,
    AdminAccountInvite,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      tableData: [],

      targetRowData: null,

      sortType: null,
      sortColumnKey: null,

      updatedIdList: [],
      listType: "default",
      showInvitePrompt: false,
      showEditPrompt: false,
      showDeletePrompt: false,

      incrementalSearchPlaceholder: "",

      searchQueryString: "",
      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },
      currentPage: 1,
      pageSize: 50,
      pageSizeOriginal: 50,

      gridApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-admin-account">表示する陸上従業員基本情報がありません</div>',
        },
        context: {
          componentParent: this,
        },
      },
      invitationGridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-admin-account">招待中のアカウントはありません</div>',
        },
        context: {
          componentParent: this,
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        icons: {
          sortAscending:
            '<span class="material-icons">keyboard_arrow_up</span>',
          sortDescending:
            '<span class="material-icons">keyboard_arrow_down</span>',
          sortUnSort: '<span class="material-icons">unfold_more</span>',
        },
        unSortIcon: true,
        comparator: () => {
          return;
        },
      },
      defaultInviteColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [],
      components: {
        CellRendererLink,
        CellRendererPassword,
      },
      prevRoute: null,
    };
  },
  async created() {
    this.initializeColumnDef();
    await this.fetchTableData(this.listType);
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  watch: {
    currentPage() {
      this.fetchTableData(this.listType);
    },
    listType(val) {
      if (val === "default") {
        this.fetchTableData(val);
      } else {
        this.fetchTableData(val);
      }
    },
    searchQueryString(_) {
      this.currentPage = 1;
      this.fetchTableData(this.listType);
    },
  },
  computed: {
    totalPages() {
      if (this.pageable) return this.pageable.total_pages;
      else return 0;
    },

    totalElement() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },

    sortColumnList() {
      return this.columnDefs.map(x => x.field.toUpperCase());
    },
  },
  methods: {
    initializeColumnDef() {
      const initialColumnDefs = [
        {
          headerName: "氏名",
          field: "name",
          minWidth: 180,
          flex: 1,
          cellRenderer: "CellRendererLink",
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "氏名(カナ)",
          field: "name_kana",
          minWidth: 180,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "部署",
          minWidth: 120,
          flex: 1,
          field: "department",
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "役職",
          minWidth: 120,
          flex: 1,
          field: "title",
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "電話番号",
          minWidth: 140,
          flex: 1,
          field: "phone",
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "メールアドレス(ID)",
          field: "email_address",
          minWidth: 200,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "操作",
          field: "action",
          minWidth: 70,
          maxWidth: 70,
          cellRendererFramework: "CellRendererRowActionButtons",
          pinned: "right",
          resizable: false,
          sortable: false,
          cellRendererParams: {
            edit: data => {
              this.targetRowData = data;
              this.showEditPrompt = true;
            },
            delete: data => {
              this.targetRowData = data;
              this.showDeletePrompt = true;
            },
          },

          cellStyle: params => this.customizeCellStyle(params),
        },
      ];
      this.columnDefs = initialColumnDefs;

      const initialInvitationColumnDefs = [
        {
          headerName: "メールアドレス(ID)",
          field: "email_address",
          minWidth: 200,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "期限",
          field: "expired_at",
          minWidth: 220,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
      ];
      this.invitationColumnDefs = initialInvitationColumnDefs;
    },

    async fetchTableData(listType) {
      if (listType == "default") {
        try {
          const query = this.getFetchTableDataSearchQuery();
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
          const res = await enterpriseAdminAccountApi.search({
            active_type: "ACTIVE",
            ...query,
          });
          this.tableData = res.data.enterprise_accounts.map(element => {
            return {
              id: element.account.id,
              name: element.profile.name,
              name_kana: element.profile.name_kana,
              department: element.profile.department,
              title: element.profile.title,
              // sort keyと変更APIのkeyが異なるため、phoneとphone_numberの両方を返す
              phone: element.profile.phone_number,
              phone_number: element.profile.phone_number,
              email_address: element.profile.email_address,
              picture: element.profile.picture,

              enterprise_account_id: element.enterprise_account_id,

              // ログイン中のアカウントは削除不可
              action_delete_disabled:
                this.$store.state.auth.user.account_id ===
                element.profile.email_address,
              isUpdated: this.updatedIdList.includes(
                element.enterprise_account_id
              ),
            };
          });
          Object.keys(res.data.pageable).forEach(key => {
            Vue.set(this.pageable, key, res.data.pageable[key]);
          });
        } finally {
          this.$vs.loading.close();
        }
      } else {
        try {
          this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
          const res = await enterpriseAdminAccountInviteApi.search();
          const usersInviting = res.data.invites;

          usersInviting.sort((a, b) => {
            // expired_at最新順でソート
            let comparison = 0;
            if (a.expired_at < b.expired_at) {
              comparison = 1;
            } else if (a.expired_at > b.expired_at) {
              comparison = -1;
            }
            return comparison;
          });

          this.tableData = usersInviting.map(element => {
            return {
              email_address: element.email_address,
              expired_at: moment(element.expired_at)
                .local()
                .format("YYYY/MM/DD HH:mm:ss"),
            };
          });
        } finally {
          this.$vs.loading.close();
        }
      }
      this.$emit("checkAlert");
    },
    onChangePage(value) {
      this.currentPage = value;
    },

    onChangePageSize(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchTableData(this.listType);
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },

    onSort(object) {
      let sortColumn = object.columnApi.columnModel.viewportColumns.find(
        element => {
          return element.sort != null;
        }
      );

      this.sortType = sortColumn ? sortColumn.sort.toUpperCase() : null;
      let sortColumnKeyLower = sortColumn ? sortColumn.colId : null;
      this.sortColumnKey = sortColumnKeyLower
        ? sortColumnKeyLower.toUpperCase()
        : null;
      this.currentPage = 1;

      this.fetchTableData(this.listType);
    },
    getFetchTableDataSearchQuery() {
      let query = {};
      if (this.searchQueryString) {
        query.name = this.searchQueryString;
      }

      query.size = this.pageSize;
      query.page = this.getCurrentPage();
      if (this.sortType && this.sortColumnKey) {
        query.sort_order = this.sortType;
        query.sort_column = this.sortColumnKey;
      }
      return query;
    },
    async onDelete() {
      this.showDeletePrompt = true;
      const enterpriseAccountId = this.targetRowData.enterprise_account_id;
      const deleteItemName = this.targetRowData.name;
      console.debug("### 削除API", enterpriseAccountId);
      try {
        this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
        await enterpriseAdminAccountApi.delete(enterpriseAccountId);
        this.$vs.notify({
          title: `陸上従業員基本情報設定`,
          text: `${deleteItemName}の基本情報を削除しました`,
          color: "success",
          icon: "done",
        });
        this.fetchTableData(this.listType);
      } finally {
        this.$vs.loading.close();
      }
    },
    onDeleteCancel() {
      this.showDeletePrompt = false;
    },

    pushUpdatedId(id) {
      if (id && !this.updatedIdList.includes(id)) {
        this.updatedIdList.push(id);
      }
    },
    customizeCellStyle(params) {
      if (this.listType === "inviting") {
        return {
          backgroundColor: "#F2F2F2",
        };
      } else {
        if (params.data.isUpdated) {
          // TODO: 更新ハイライトのライフサイクルを確認
          return {
            backgroundColor: "lightyellow",
          };
        }
      }
      return null;
    },

    changeSearchQueryBoxWidth() {
      let inputEl = this.$refs.incrementalSearch.$el;
      if (inputEl) {
        inputEl.style.border = `1px solid ${this.AISEA_COLOR.BLUE}`;
        inputEl.style.width = "12rem";
        this.incrementalSearchPlaceholder = "氏名で検索";
      }
    },

    clearSearchQueryString() {
      this.searchQueryString = "";
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#admin-account-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: 100%;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .ag-header-cell-text {
      font-family: $aisea-font-family;
      font-size: 12px;
      font-weight: 600;
    }

    .ag-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
    .ag-header-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .ag-header-cell {
    padding-right: 0;
  }
  .vs-tabs--content {
    padding: 4px 0 0 0;
  }

  .crew-incremental-search {
    border-radius: 6px;
    width: 2rem;
    transition: all 0.2s 0s ease;

    .vs-inputx {
      background-color: $aisea-pure-white;
      // color: $aisea-dark-gray !important;
      border: none !important;
      // padding-left: 2rem !important;
      padding: 10px 0 8px 2rem !important;
      font-family: $aisea-font-family;
      font-size: 16px !important;
      font-weight: 400;
      color: $aisea-dark-gray;
    }
    .vs-input--icon {
      border-right-color: #ffffff00;
      margin-top: 0.2rem;
      font-size: 16px;
    }
    .vs-input--input:focus {
      box-shadow: 0 3px 10px 0 rgba($aisea-blue, 0.15);
    }
    .vs-input--placeholder {
      color: $aisea-light-gray !important;
      padding-left: 1.8rem !important;
      padding-top: 0.8rem !important;
    }
  }
  .sort-icons {
    flex-direction: column;
    z-index: 9;
    i {
      cursor: pointer;
      border-radius: 4px;
      &:hover {
        background-color: $aisea-white;
      }
    }
  }
  .vs-pagination--ul {
    span {
      font-size: 12px;
      font-family: $aisea-font-family;
      font-weight: 400;
    }
  }
  #admin-account-list-hover-menu {
    height: 0;
    right: 31px;

    .admin-account-list-hover-icon {
      border-radius: 4px;
      padding: 8px;
      &:hover {
        background-color: $aisea-light-white;
      }
    }
    .disabled-hover-icon {
      color: $aisea-light-gray;
      &:hover {
        background-color: $aisea-slightly-gray;
      }
    }
  }
  .list-type-button {
    display: flex;
    align-items: center;
    padding: 0 1rem;
    height: 32px;
    border-radius: 15px;

    font-family: $aisea-font-family;
    font-size: 14px;

    &--selected {
      border: 1px solid $aisea-blue;
      padding-bottom: 4px;
      background-color: $aisea-blue;
      color: $aisea-pure-white;
      font-weight: 600;
      &:hover {
        background-color: #0277bd;
      }
    }
    &--default {
      border: 1px solid $aisea-light-gray;
      padding-bottom: 0px;
      background-color: none;
      color: none;
      font-weight: 400;
      &:hover {
        color: $aisea-blue;
        border-color: $aisea-blue;
      }
    }
  }
}
.admin-account-list-delete-confirm {
  .vs-dialog {
    min-width: 560px;

    .vs-dialog-header {
      color: $aisea-black !important;
    }

    .dialog-title {
      color: $aisea-black !important;
      font-family: $aisea-font-family !important;
      font-size: 18px;
    }

    .admin-account-list-delete-confirm-body {
      font-family: $aisea-font-family !important;
      font-size: 16px;
    }

    .vs-dialog-cancel {
      background-color: rgba(244, 244, 244, 0) !important;
      transform: none !important;
      box-shadow: none !important;
    }
  }
}
</style>
